<template>
  <div>
    <!-- Button trigger modal -->
    <div type="button" class="settings-item" data-bs-toggle="modal" data-bs-target="#changePasswordModal">
      <!-- <div class="settings-item"> -->
        <div class="settings-icon">
          <i class="bi bi-lock-fill"></i>
        </div>
        <div class="settings-content">
          <h5>Change Password</h5>
          <p>Update your account password</p>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="changePasswordModalLabel">🔑 Change Password</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
  <form @submit.prevent="handleChangePassword">
    <!-- Current Password -->
    <div class="mb-3 position-relative">
      <label class="form-label">Current Password</label>
      <input
        :type="showCurrent ? 'text' : 'password'"
        v-model="current_password"
        class="form-control pe-5"
        required
      />
      <i
        class="bi"
        :class="showCurrent ? 'bi-eye-slash' : 'bi-eye'"
        @click="showCurrent = !showCurrent"
        style="cursor: pointer; position: absolute; top: 38px; right: 12px;"
      ></i>
    </div>

    <!-- New Password -->
    <div class="mb-3 position-relative">
      <label class="form-label">New Password</label>
      <input
        :type="showNew ? 'text' : 'password'"
        v-model="new_password"
        class="form-control pe-5"
        required
        minlength="8"
      />
      <i
        class="bi"
        :class="showNew ? 'bi-eye-slash' : 'bi-eye'"
        @click="showNew = !showNew"
        style="cursor: pointer; position: absolute; top: 38px; right: 12px;"
      ></i>
    </div>

    <!-- Confirm New Password -->
    <div class="mb-3 position-relative">
      <label class="form-label">Confirm New Password</label>
      <input
        :type="showConfirm ? 'text' : 'password'"
        v-model="new_password_confirmation"
        class="form-control pe-5"
        required
      />
      <i
        class="bi"
        :class="showConfirm ? 'bi-eye-slash' : 'bi-eye'"
        @click="showConfirm = !showConfirm"
        style="cursor: pointer; position: absolute; top: 38px; right: 12px;"
      ></i>
    </div>

    <!-- Submit -->
    <button type="submit" class="btn btn-danger w-100" :disabled="loading">
      <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
      Change Password
    </button>
  </form>

  <!-- Alerts -->
  <div v-if="message" class="alert mt-3" :class="alertClass">
    {{ message }}
  </div>
</div>

          <!-- Modal Footer -->
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      current_password: "",
      new_password: "",
      new_password_confirmation: "",
      showCurrent: false,
      showNew: false,
      showConfirm: false,
      loading: false,
      message: null,
      alertClass: "alert-info",
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    async handleChangePassword() {
      this.loading = true;
      this.message = null;

      try {
        const response = await axios.post(
          "/change-password",
          {
            current_password: this.current_password,
            new_password: this.new_password,
            new_password_confirmation: this.new_password_confirmation,
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          }
        );

        this.message = response.data.message;
        this.alertClass = "alert-success";

        // Reset form
        this.current_password = "";
        this.new_password = "";
        this.new_password_confirmation = "";
      } catch (error) {
        this.message = error.response?.data?.message || "Failed to change password.";
        this.alertClass = "alert-danger";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>

@import "@/assets/styles/settings.scss";

.container {
  margin-top: 5%;
  position: relative;
  max-width: 500px;
}

.form-label {
  font-weight: 500;
}

/* Mobile responsiveness */
@media (max-width: 576px) {
  .form-control {
    font-size: 0.9rem;
    padding: 0.6rem 0.75rem;
  }

  .btn {
    font-size: 0.9rem;
    padding: 0.6rem;
  }
}
</style>
